var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 9.375H22.8516C23.1738 9.375 23.4375 9.63867 23.4375 9.96094V22.6562C23.4375 23.9502 22.3877 25 21.0938 25H3.90625C2.6123 25 1.5625 23.9502 1.5625 22.6562V9.96094C1.5625 9.63867 1.82617 9.375 2.14844 9.375ZM23.4375 7.22656V5.46875C23.4375 4.1748 22.3877 3.125 21.0938 3.125H18.75V0.585938C18.75 0.263672 18.4863 0 18.1641 0H16.2109C15.8887 0 15.625 0.263672 15.625 0.585938V3.125H9.375V0.585938C9.375 0.263672 9.11133 0 8.78906 0H6.83594C6.51367 0 6.25 0.263672 6.25 0.585938V3.125H3.90625C2.6123 3.125 1.5625 4.1748 1.5625 5.46875V7.22656C1.5625 7.54883 1.82617 7.8125 2.14844 7.8125H22.8516C23.1738 7.8125 23.4375 7.54883 23.4375 7.22656Z",
    fill: "#2e333e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bf2a9e4f.svg";
export { ForwardRef as ReactComponent };